import React, { useEffect, useState } from "react";
import { useIndexedDB } from "react-indexed-db";
import { styled } from "../stitches.config";
import Footer from "../redesign/components/Footer"

const PrivacyPage = () => {
  const [visitedCategories, setVisitedCategories] = useState([]);
  const [visitedArticles, setVisitedArticles] = useState([]);
  const { getAll: getAllVisitedCategories } = useIndexedDB("visitedCategories");
  const { getAll: getAllVisits } = useIndexedDB("visit");

  useEffect(() => {
    getAllVisitedCategories().then((categories) =>
      setVisitedCategories(categories)
    );
    getAllVisits().then((articles) => setVisitedArticles(articles));
  }, []);

  return (
    <>
      <Wrapper>
        <Table>
          <thead>
            <tr>
              <th colspan="3">Odwiedzone artykuły</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Artykuł ID</td>
              <td>Kategoria ID</td>
              <td>Data</td>
            </tr>
            {visitedArticles.map(({ articleId, categoryId, datetime }) => (
              <tr>
                <td>{articleId}</td>
                <td>{categoryId}</td>
                <td>
                  {datetime.toLocaleDateString()} {datetime.toLocaleTimeString()}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Table>
          <thead>
            <tr>
              <th colspan="2">Odwiedzone kategorie</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Kategoria ID</td>
              <td>Ilość odwiedzin</td>
            </tr>
            {visitedCategories.map(({ categoryId, count }) => (
              <tr>
                <td>{categoryId}</td>
                <td>{count}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Wrapper>
      <Footer />
    </>
  );
};
const Wrapper = styled("div", {
  margin: "10vh auto",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
  width: '60vw'
});
const Table = styled("table", {
  margin: "5vh 0",
  border: "1px solid #ccc",
  width: "100%",
  tableLayout: "fixed",
  tr: {
    backgroundColor: "#f8f8f8",
    border: "1px solid #ddd",
    padding: ".35em",
  },
  th: {
    padding: ".625em",
    textAlign: "center",
    fontSize: ".85em",
    letterSpacing: ".1em",
    textTransform: "uppercase",
  },
  td: {
    padding: ".625em",
    textAlign: "center",
  },
});

export default PrivacyPage;
